<template>
  <validation-observer ref="word-values-observer">
    <b-row>
      <b-col md="6" class="mb-2">
        <label :for="'i-current-value-' + request.id">
          {{ $t('Current value') }}
        </label>
        <b-form-input
          :id="'i-current-value-' + request.id"
          v-model="oldValue"
          disabled
        />
      </b-col>
      <b-col md="6" class="mb-2">
        <label :for="'i-new-value-' + request.id">
          {{ $t('New value') }}
        </label>
        <validation-provider
          v-slot="{ errors }"
          name="newValue"
          rules="required"
          mode="lazy"
        >
          <b-form-input
            :id="'i-new-value-' + request.id"
            v-model="newValue"
          />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-col>
    </b-row>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCard,
  BCardText,
  BCol,
  BFormInput,
  BFormGroup,
  BRow,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@mentoring-platform-validations";

export default {
  components: {
    BButton,
    BCard,
    BCardText,
    BCol,
    BFormInput,
    BFormGroup,
    BRow,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      newValue: null,
      oldValue: null
    };
  },
  created() {
    this.oldValue = this.request.old_value;
    this.newValue = this.request.new_value;
  },
  methods: {
    isValid() {
      return this.$refs['word-values-observer'].validate().then((success) => success);
    },
    collectData() {
      return {
        new_value: this.newValue
      }
    }
  }
};
</script>